/**
 * The Symagic Server Resource entity.
 * @author Tom Verschoore de la Houssaije
 */
import { BreezeService } from '../../core/breeze.service';
import { EventEmitter } from '@angular/core';
/**
 * The Symagic Server Resource entity.
 */
var Resource = /** @class */ (function () {
    function Resource() {
        /**
         * Reference to plan of resource retrieved by PlanboardGridDisplayComponent
         * or AgendaGridDisplayComponent.
         * @private
         * @type {DataSet}
         */
        this._$row = null;
        /**
         * The event is triggered by PlanboardGridDisplayComponent to indicate that a new plan is retrieved.
         * The event is used by PlanboardRowInfoComponent to update its info.
         */
        this.onRowChanged = new EventEmitter();
    }
    /**
     * Invokes the remote method FillWith of this entity.
     * FillWith tries to plan work for this resource according the include options.
     * @param {string} work The work to plan.
     * @param {Date} start The start of the drop zone.
     * @param {Date} finish The finish of the drop zone.
     * @param {string} include The include options.
     * @param {boolean} [afterSave=false] The entity property changes are committed first when true otherwise the method is invoked first.
     */
    Resource.prototype.fillwith = function (work, start, finish, include, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        BreezeService.invokeMethod(this, 'FillWith', [work, start, finish, include], afterSave);
    };
    /**
     * Sets a new plan retrieved by PlanboardGridDisplayComponent or AgendaGridDisplayComponent.
     * @param {DataSet} value The set containing the plan of the resource.
     */
    Resource.prototype.$setRow = function (value) {
        // Was eerst een: 'public set $row', maar breeze gaat daar onhandig tussen zitten
        this._$row = value;
        this.onRowChanged.emit(value);
    };
    /**
     * Gets a the resource plan retrieved by PlanboardGridDisplayComponent or AgendaGridDisplayComponent.
     * @readonly
     * @type {DataSet}
     */
    Resource.prototype.$getRow = function () {
        // Was eerst een: 'public get $row', maar breeze gaat daar onhandig tussen zitten
        return this._$row;
    };
    return Resource;
}());
export { Resource };
